import { Box, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import { useTheme } from '@mui/styles';
import * as React from 'react';

type PropsType = {
  startTextFieldProps: TextFieldProps;
  endTextFieldProps: TextFieldProps;
};

export const OrgUnitDateRangeTextFields = (props: PropsType) => {
  const { startTextFieldProps, endTextFieldProps } = props;
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex' }}>
      <TextField {...startTextFieldProps} />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: theme.spacing(0.5),
        }}
      >
        -
      </Box>
      <TextField {...endTextFieldProps} />
    </Box>
  );
};
